export default "__VITE_ASSET__SoaXe9YxlNqn8Z1ElY$2Jg__"